<template>
  <div class="range-input">
    <div class="range-input__label">
      {{ fields.label }}
    </div>
    <div class="range-input__container">
      <FormulateInput v-bind="fields.min">
        <template v-if="fields.min.suffix" #suffix>
          <div class="formulate-input-suffix">
            <span>{{ fields.min.suffix }}</span>
          </div>
        </template>
      </FormulateInput>
      <div class="range-input__divider"></div>
      <FormulateInput v-bind="fields.max">
        <template v-if="fields.max.suffix" #suffix>
          <div class="formulate-input-suffix">
            <span>{{ fields.max.suffix }}</span>
          </div>
        </template>
      </FormulateInput>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => {}
    },
  },
}
</script>

<style lang="scss" scoped>
.range-input {
  &__label {
    margin: 16px 0;
    padding: 0 4px;
    color: $mep-color-text-300;
  }

  &__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 11px;
  }

  &__divider {
    height: 50px;
    width: 20px;
    border-bottom: 1px solid $mep-color-text-200;
  }
}
</style>
